import React from 'react'

import { useProductsInQueueContext } from 'containers/ProductsInQueueProvider/ProductsInQueueProvider'
import BestsellersBlock from 'compositions/landings/BestsellersBlock/BestsellersBlock'

import messages from './messages'


type BestsellersSectionProps = {
  className?: string
}

const BestsellersSection: React.FunctionComponent<BestsellersSectionProps> = ({ className }) => {
  const { updateCount } = useProductsInQueueContext()

  return (
    <BestsellersBlock
      id="products"
      className={className}
      title={messages.title}
      withRetailPrice
      buttonProps={{
        withNotification: false,
        withNonAuthRedirect: false,
        withErrorModals: false,
        force: true, // to add lep products to queue for users with subscription.hasNeverSubscribed
        metadata: {
          placement: 'Bestsellers',
        },
        onClick: updateCount,
      }}
    />
  )
}


export default React.memo(BestsellersSection)
